
import { motion } from 'framer-motion';

export default function AboutCTA() {
  return (
    <section className="relative py-20 sm:py-32 bg-[#111111] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2025de98705a411570128e52739adb90.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#111111] via-[#111111]/90 to-[#111111]"></div>
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#00E5FF]/5 rounded-full blur-[150px] pointer-events-none"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span
            className="text-[#00E5FF] text-xs tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Współpraca
          </span>

          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-4 mb-6 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Gotowy na <span className="text-[#00E5FF]">Współpracę?</span>
          </h2>

          <p
            className="text-sm sm:text-lg text-[#C0C7CF] mb-10 max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Skontaktuj się z nami i omów szczegóły swojego projektu. Nasz zespół ekspertów
            jest gotowy pomóc w realizacji nawet najbardziej wymagających konstrukcji.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/kontakt"
              className="w-full sm:w-auto inline-block px-10 py-4 bg-[#00E5FF] text-[#050505] font-bold text-sm hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_0_25px_rgba(0,229,255,0.2)]"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Rozpocznij projekt
            </a>
            <a
              href="/uslugi"
              className="w-full sm:w-auto inline-block px-10 py-4 border border-[#C0C7CF]/30 text-[#C0C7CF] font-bold text-sm hover:border-[#00E5FF] hover:text-[#00E5FF] transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Poznaj usługi
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
